<template>
  <div class="row p-5" id="cover-page">
    <div
      class="col-sm-10 col-md-12 d-flex justify-content-center text-center align-items-center button-container"
    >
      <img
        class="cover-image border-radius-2 border w-50"
        :src="
          'https://assets.beereaders.com/lbr/image/' +
            resource_dir +
            '/cover_medium.jpg'
        "
      />
      <button
        class="btn br-button-primary m-0 px-4 py-1 border-radius-5"
        @click="started"
      >
        Comenzar
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

export default {
  name: "br-book-cover",
  props: ["resource_dir"],
  methods: {
    ...mapMutations(["getStarted"]),
    ...mapActions(["startBook"]),
    started() {
      window.scrollTo(0, 0);
      this.startBook();
    },
  },
};
</script>

<style lang="css">
.button-container a,
.button-container button,
.button-container .btn,
.button-container .button {
  position: absolute;
  bottom: 3vh;
  font-size: 22px !important;
  box-shadow: black -1px 3px 12px 0px;
}
</style>
